import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { DecorRoomItem } from "$/game/prefabs/DecorRoomItem.ts";

export class PictureDecorObject extends DecorRoomItem {
  constructor(private myScene: BasicScene, x: number, y: number) {
    super(
      myScene,
      x,
      y,
      myScene.atlas,
      myScene.keys.assets.sprites.decor.picture,
    );
  }
}
